export const internalItAssetStates = ["deployable", "deployed", "retired"];
